import React from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import { dateFormat } from '../../util/DateUtil';

const useStyles = makeStyles({
    card: {
        width: 'fit-content'
    },
});

export default function DataProfile({ dataCalendar, handleTrocaDataCalendar }) {
    const classes = useStyles();

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <div style={{
                    display: 'flex'
                }}>
                    <div style={{
                        marginRight: '30px'
                    }}>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            Data
                        </Typography>
                        <Typography variant="body1" >
                            {dateFormat(dataCalendar)}
                        </Typography>
                    </div>
                </div>
                <CardActions>
                    <Button
                        onClick={handleTrocaDataCalendar}
                        size="small"
                        color="secondary"
                        variant="contained"
                    >Trocar Data</Button>
                </CardActions>

            </CardContent>
        </Card>
    );
}